import { Component, OnInit } from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-aesthetic-ethics-report',
  templateUrl: './aesthetic-ethics-report.component.html',
  styleUrls: ['./aesthetic-ethics-report.component.scss']
})
export class AestheticEthicsReportComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
